import { services } from '../../services';
var action = "manage/payment";

export const paymentService = {
    getList,
    getOne,
    receivePayment,
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/detail/${id}`, 'GET');
}

function receivePayment(object) {
    return services.restApi(`${action}/receive-payment`, 'POST', object);
}

